<template>
  <div class="container-fluid">
    <div class="row">
      <img 
      :src="isMobile ? require('@/assets/img/banner-hp-mcafee-mobile.svg') : require('@/assets/img/banner-hp-mcafee-web.svg')"
      alt="Segurança digital com a McAfee" 
      class="mx-auto col-12 row styleImg">
     </div>
     <div class="mt-2">
      <div class="col-12 mt-4 d-flex h-100 align-items-center justify-content-center">
        <div class="row">
          <ul class="list-group list-group-flush">
            <li v-for="(item, index) in items" :key="index" class="list-group-item">
              <svg 
                :xmlns="item.iconXmlns" 
                :width="item.iconWidth" 
                :height="item.iconHeight" 
                :fill="item.iconFill" 
                :class="item.iconClass" 
                :viewBox="item.iconViewBox">
                <path :d="item.iconPath"/>
              </svg>
              <span class="mx-2" :class="item.textClass">{{ item.text }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12 mt-3 mb-4 d-flex h-100 align-items-center justify-content-center">
        <Carousel/>
      </div>    
      <div class="container  margin-right-mobile section-container-one">
        <div class="row">
          <div class="col-md-6 order-2 order-md-1 align-items-center justify-content-center">
            <div>
              <img src="@/assets/img/digitando-web.jpg" alt="Navegação Segura com McAfee" class="img-fluid">
            </div> 
          </div>
          <div class="col-md-6 order-1 order-md-2 mt-2 d-flex align-items-center justify-content-center justify-content-md-start">
            <div>
              <h3 class="custom-heading-section-container-one">É mais do que apenas<br> um software antivírus,<br>é <strong class="colorRed">tranquilidade</strong></h3>
              <br>
              <p class="custom-description-section-container-one">    
              Defenda você e a toda a família contra os mais recentes ataques de vírus, malware, spyware e ransomware, ao mesmo tempo em que mantém o controle de sua privacidade e identidade.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <div class="row d-flex justify-content-center align-items-center bgColorGray py-4">
          <div class="col-md-6 col-lg-1">
            <div class="d-flex justify-content-center align-items-center">
              <span><img src="@/assets/img/companies/McAfee/McAfeeCommon/Group8.svg" width="50" height="50" alt="" class="img-fluid"></span>
            </div> 
          </div>
          <div class=" col-md-6 col-lg-6">
            <div class="fontMedium text-md-left text-lg-start text-center">
              <h5>
              Mais de <strong>400 milhões de clientes </strong> compram, jogam e navegam online com segurança.<strong>Seja um deles!</strong>
              </h5>
            </div>
          </div>
        </div>
    </div>
    <div class="container-fluid gradRed">
      <div class="h-100 d-flex align-items-center justify-content-center">
        <p class="mt-5">
          <span class="align-items-center justify-content-center colorWhite p-lg-3 px-1 custom-description-section-container-three">Porque a McAfee?</span>
        </p>
      </div>
      <div class="container-fluid border border-white rounded custom-img-section-container-three">
        <div class="h-100 d-flex align-items-center justify-content-center mt-4 px-4 ">
          <p class="mt-2">
            <img src="@/assets/img/companies/McAfee/McAfeeCommon/1640015279080.png.png" width="120" height="110" alt="" class="img-fluid">
          </p>
        </div>
        <div class="h-100 d-flex align-items-center justify-content-center mb-4">
          <span class="mt-2 colorWhite text-justify text-center text-free">
            Teste grátis por 30 dias.
            <span class="mt-2 colorWhite text-center text-cancel">
            Cancele sem custos durante esse período.
          </span>
          </span>
          <br>
        </div>
      </div>
      <div class="h-100 d-flex align-items-center justify-content-center mb-4 mt-4">
        <div class="row mb-5">
          <ul class="list-group bg-transparent bg-transparent">
            <li class="list-group-item bg-transparent border-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-check-circle colorWhite" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
              </svg>
              <span class="colorWhite px-2">Mais de 600 milhões de dispositivos de clientes protegidos até agora. </span>
            </li>
            <li class="list-group-item bg-transparent border-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-check-circle colorWhite" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
              </svg>
              <span class="colorWhite px-2">31 vezes vencedor da escolha do editor da PCMag (PC Mag Editor's Choice).</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container mt-3">
      <div class="row">
        <div class="col-md-6 mt-5 d-flex align-items-center justify-content-center">
          <div>
            <img src="@/assets/img/computer-office.png" width="500" height="350" alt="Navegação Segura com McAfee" class="img-fluid">
          </div> 
        </div>
        <div class="col-md-4 mt-2 d-flex align-items-center justify-content-center">
          <div>
            <h3 class="custom-heading-section-container-four"><strong class="colorRed">Tranquilidade</strong> para cada<br> PC, telefone e tablet</h3>
            <br>
            <p class="custom-description-section-container-four">Proteja todos os seus dispositivos com<br> uma assinatura que cobre todos  os <br>dispositivos em sua casa.Essa é a<br> proteção que pode ajudar a manter toda <br> a família segura.</p>
            <div class="row mb-5">
              <span class="fontSmall">Windows® | macOS® | Android™ | iOS®</span>
            </div>
          </div>      
        </div>
      </div>
    </div>
    <div class="container-fluid mb-2 bgColorGray custom-height">
      <div class="row justify-content-center custom-width mx-auto">
        <template v-for="(section, index) in sections" :key="index">
          <div class="col-md-6 mb-3"> 
            <div class="d-flex flex-column align-items-start">
              <img :src="section.iconSrc" width="50" height="40" alt="" class="img-fluid mt-2">
              <div>
                <p class="fontMedium mt-2 mb-2 custom-heading-section-container-five">
                  <strong>{{ section.title }}</strong>
                </p>
                <p class="pclass mb-2 custom-description-section-container-five">
                  {{ section.description }}
                </p>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="col-12 d-flex align-items-center justify-content-center content-faq">
      <div class="row">
        <p class="mt-3 custom-heading-section-container-six">
          <strong>FAQs</strong>
        </p>
      </div>
    </div>
    <div class="col-12 d-flex align-items-center justify-content-center ">
      <div class="row">
        <p class="mb-4 px-4 custom-description-section-container-six">
          Essas respostas podem ajudar
        </p>
      </div>
    </div>  
    <div class="col-12 col-md-6 mt-0 d-flex  accordion-container mx-auto" v-for="(item, index) in accordionItems" :key="index">    
      <Accordion :accordionKey="index" class="mb-2">
        <template v-slot:title>
          <span class="colorBlack custom-heading-section-container-seven">{{ item.title }}</span>
        </template>
        <template v-slot:content>
          <span class="colorBlack">{{ item.content }}</span>
        </template>
      </Accordion>
    </div>
  </div>
</div>
</template>
<script>
import Carousel from "@/components/Carousel/McafeeHpCarouselComponent"
import Accordion from "@/components/Accordion/McafeeHpAccordionComponent"
export default {
  name: "HomepageHPmcafee",
  components: {
    Carousel,
    Accordion
  }, 
  props: {
    title: String
  },
  data() {
    return {
      isMobile: false,
      mobileWidth: 475,
      accordionItems: [
        {
          title: 'Como funciona o teste grátis de 30 dias McAfee?',
          content: 'Ao selecionar o produto McAfee que melhor se adequa ao seu perfil e preencher seus dados de cadastro, você receberá um e-mail da McAfee com a chave da sua licença para realizar a instalação. Você poderá usar a solução completa da McAfee durante esses 30 dias de graça. A cobrança no seu cartão será feita somente após esse período e conforme a quantidade de parcelas que escolher.'
        },
        {
          title: 'Como faço o cancelamento da minha assinatura durante o período de teste?',
          content: 'É bem simples. Caso queira cancelar o seu serviço McAfee durante o período de teste, basta entrar em contato conosco pelo nosso WhatsApp de atendimento (11 99307-5497), informar os dados da sua licença e fazemos seu cancelamento. Importante se atentar ao período de 30 dias contados a partir da data da contratação. Após esse período, o valor será cobrado automaticamente no seu cartão de crédito.'
        },
        {
          title: 'O que o McAfee Multi Dispositivo cobre?',
          content:'Na sua essência, o McAfee Multi Dispositivo oferece nosso premiado antivírus para defendê-lo contra vírus, ameaças on-line e ransomware com proteção on-line e off-line com base na nuvem. Além de PCs com Windows, o McAfee Multi Dispositivo oferece proteção entre dispositivos para Macs e dispositivos móveis iOS/Android, o que aumenta sua tranquilidade para que desfrute da segurança, dentro ou fora de casa, em todos seus dispositivos compatíveis. A proteção Web do McAfee® WebAdvisor evita ataques antes que eles ocorram, fornecendo avisos claros de sites, links e arquivos arriscados, para que você possa navegar, comprar e fazer transações bancárias com confiança. Os recursos de otimização do PC ajudam o seu computador a funcionar mais rápido, enquanto garentem que você tenha segurança de alto nível. O Web Boost ajuda a resgatar a bateria e a largura de banda dos desagradáveis vídeos de reprodução automática pausando-os automaticamente. E com o Acelerador de aplicativo, os aplicativos com os quais você está trabalhando ativamente receberão automaticamente uma otimização dos recursos para que você execute seu trabalho mais rapidamente. Uma vez que grande parte da sua vida digital reside nos arquivos do seu computador, você pode usar o McAfee® QuickClean™ e Shredder™ para gerenciar sua privacidade. Use o McAfee QuickClean para remover arquivos temporários e cookies, a fim de recuperar espaço de armazenamento e minimizar a exposição. E, quando você deseja descartar arquivos confidenciais, o Destruidor de arquivos da McAfee os exclui com segurança, para que os supostos ladrões não possam juntar as peças. Nossas senhas são as chaves do nosso reino digital. Acabe com a complicada tarefa de criar e lembrar senhas complexas com nosso gerenciador de senhas, que pode armazenar, preencher automaticamente e até gerar senhas complexas exclusivas. Para maior comodidade, você pode acessar suas senhas compartilhadas no seu PC e dispositivos móveis com uma única conta. Muitas vulnerabilidades do seu PC se devem a aplicativos desatualizados. Com o mecanismo de varredura de vulnerabilidades, você pode atualizar o Windows e seus aplicativos de um mesmo lugar, simplificando as atualizações do Windows e de aplicativos com uma única ferramenta que varre e instala atualizações críticas. O Serviço de proteção de identidade fornece uma experiência de proteção de identidade guiada, incluindo monitoramento da dark web para seu e-mail. Para obter mais informações, acesse esta página. Em caso de dúvidas, o atendimento gratuito ao cliente estará disponível quando você precisar, seja por telefone, bate-papo ou on-line.'
          },
          {
          title: 'O McAfee Multi Dispositivo remove vírus?',
          content:'Depois que o McAfee Multi Dispositivo estiver instalado, você poderá verificar se há vírus e colocá-los em quarentena/removê-los.'
          },
          {
          title: 'Como faço para usar o McAfee Multi Dispositivo?',
          content:'Ao abrir o McAfee Multi Dispositivo pela primeira vez após a instalação, você será recepcionado por um tour guiado que o ajudará a executar verificações e descobrir recursos.'
          },
          {
          title: 'Quantos dispositivos posso usar com o McAfee Multi Dispositivo?',
          content:'O McAfee Multi Dispositivo está disponível em dois pacotes: individual, que cobre um dispositivo; o pacote multidispositivo, que cobre cinco dispositivos. O software McAfee é compatível com dispositivos Windows, Mac OS, iOS e Android.'
          },
          {
          title: 'Preciso renovar minha assinatura da McAfee?',
          content:'Quando você está inscrito na renovação automática, 30 dias antes de sua assinatura expirar, é efetuada a cobrança automática no cartão de crédito arquivado em sua conta e a assinatura é estendida por mais um ano. Se a renovação automática tiver sido desativada, você receberá uma mensagem 30 dias antes da expiração para informá-lo de que a licença está prestes a expirar. Você pode optar por renovar sua licença por mais um ano ou adquirir uma atualização.'
          },
          {
          title: 'O que acontece se eu não renovar o McAfee?',
          content:'Se a assinatura do McAfee Multi Dispositivo expirar, seu software e segurança serão desativados. Quando a assinatura do seu software antivírus atingir a data de vencimento, você precisará decidir se deseja se inscrever novamente, comprar outra solução ou instalar uma solução gratuita. Caso contrário, seu computador ficará suscetível a inúmeras ameaças de vírus.'
          },
           {
          title: 'Quais dispositivos e sistemas operacionais são compatíveis com o McAfee Multi Dispositivos?',
          content:'O McAfee Multi Dispositivo é compatível com notebooks, desktops, tablets e dispositivos móveis. Você pode encontrar a compatibilidade com os sistemas operacionais em nossa página Requisitos do sistema.'
           }
      ],
        items: [
        {
          iconXmlns: "http://www.w3.org/2000/svg",
          iconWidth: "30",
          iconHeight: "30",
          iconFill: "currentColor",
          iconClass: "bi bi-check-lg, colorSucess",
          iconViewBox: "0 0 16 16",
          iconPath: "M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z",
          text: "Agora você pode parcelar sua assinatura em até 12x sem juros.",
          textClass: "colorRed" 
        },
        {
          iconXmlns: "http://www.w3.org/2000/svg",
          iconWidth: "30",
          iconHeight: "30",
          iconFill: "currentColor",
          iconClass: "bi bi-check-lg, colorSucess",
          iconViewBox: "0 0 16 16",
          iconPath: "M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z",
          text: "Proteja seus dispositivos. Compatível com Windows, Mac, iOS e Android."
        },
        {
          iconXmlns: "http://www.w3.org/2000/svg",
          iconWidth: "30",
          iconHeight: "30",
          iconFill: "currentColor",
          iconClass: "bi bi-check-lg, colorSucess",
          iconViewBox: "0 0 16 16",
          iconPath: "M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z",
          text: "1 ano completo de proteção para você e seus dispositivos."
        },
        {
          iconXmlns: "http://www.w3.org/2000/svg",
          iconWidth: "30",
          iconHeight: "30",
          iconFill: "currentColor",
          iconClass: "bi bi-check-lg, colorSucess",
          iconViewBox: "0 0 16 16",
          iconPath: "M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z",
          text: "Proteja sua família contra vírus, malware e ameaças online."
        }
      ],
        sections: [
        {
          iconSrc: require('@/assets/img/companies/McAfee/McafeeHP/Password.png'),
          title: 'Gerenciador de senhas',
          description: 'Cria senhas fortes e exclusivas para todas as suas contas on-line, além de salvar e lembrar delas, para que você não precise fazer isso.'
        },
        {
          iconSrc: require('@/assets/img/companies/McAfee/McafeeHP/Clock.png'),
          title: 'Proteção contra ameaças em tempo real',
          description: 'Proteção 24 horas por dia, 7 dias por semana para todos os dispositivos contra malware e ameaças on-line em constante evolução.'
        },
        {
          iconSrc: require('@/assets/img/companies/McAfee/McafeeHP/Carbon_Trophy.png'),
          title: 'Antivírus premiado',
          description: 'A análise de ameaças baseada em nuvem mantém você protegido contra vírus, incluindo ransomware, sem atrasá-lo.'
        },
        {
          iconSrc: require('@/assets/img/companies/McAfee/McafeeHP/easy.png'),
          title: 'Fácil de usar',
          description: 'Um console fácil de usar baseado na Web permite proteger e gerenciar todos os seus dispositivos em um só lugar.'
        }
      ]
    };
  },
  methods:{
    handleResize() {
      this.isMobile = window.innerWidth <= this.mobileWidth;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }  
}
</script>
<style lang="scss" scoped>
.colorBlack {
  color: #000;
}
.colorRed {
  color: crimson;
}
.colorWhite {
  color: #FFFFFF;
}
.bgColorGray {
  background-color: #F3F3F3;
}
.fontSmall {
  font-size: 12px;
}
.fontMedium {
  font-size: 22px;
}
.gradRed {
  background-image: linear-gradient(deeppink, red);
}
.colorSucess{
  color: #1DA15A;
}
.pclass{
  text-align: left;
} 
.styleImg{
  width: 100%;
  padding: 0;
}
.text-free {
  font-family: Roboto;
  font-size: 26px;
  font-weight: 700;
  line-height: 36px;
  text-align: center;
}
.text-cancel {
  font-family: Roboto;
  font-size: 15px;
  font-weight: 700;
  line-height: 36px;
  text-align: center;
}
@media (min-width: 320px) and (max-width: 768px) {
  .custom-description-section-container-one {
    width: auto !important;
  }
  .margin-right-mobile{
    margin-right: 0px;
  }
  .accordion-container {
    width: 100%;
    margin: auto;
  }
  .content-faq {
    margin-top: 10px;
  }
}
.custom-width {
  max-width: 1100px; 
}
.accordion-container {
  margin: auto;
}
.section-container-one {
    margin-right: 50px;
}
.custom-heading-section-container-one{
  font-size: 28px;
}
.custom-description-section-container-one {
  font-size: 16px; 
  width:300px;
}
.custom-description-section-container-three{
  font-size: 30px;
}
.custom-img-section-container-three{
  width: 350px; 
  border-radius: 30px!important;
}
.custom-heading-section-container-four{
  font-size: 28px;
}
.custom-description-section-container-four{
  font-size: 16px;
}
.custom-heading-section-container-five{
  font-size: 18px;
}
.custom-description-section-container-five{
  font-size: 14px;
}
.custom-heading-section-container-six{
  font-size: 24px;
}
.custom-description-section-container-six{
  font-size: 16px;
}
.custom-heading-section-container-seven{
  height: 50px;
  display: flex;
  align-items: center;
  font-size: 14px
}
</style>